<template>
  <div id="mySidenav" class="sidenav">
    <template v-if="selectedMarker">
      <div class="sidenav-header">
        <div class="sidenav-header-title">
            <h3 class="sidenav-h3">
              <span class="flight-iata">{{ selectedMarker.flightIata }}</span>
                /{{ selectedMarker.flightIcao }}
            </h3>
            <span class="airline"> {{ selectedMarker.airlineName }}</span>
            <img src="../assets/Version2_DATAFuer.png" alt="logo datafuer" class="logo-datafuer">
        </div>
        <img src="../assets/airplane-flying-in-cloudy-sky-crop.jpg"
          alt="avion volando entre las nubes"
          class="airplane-img"
        >
        <div class="sidenav-content">
          <div class="row">
            <div class="col-6">
              <p class="airport-title">{{ $t('airportDep') }}</p>
              <div class="airport-box">
                <p class="airport-iata">{{ selectedMarker.airportDepIata }} </p>
                <p class="airport-name">
                  {{ selectedMarker.airportDepName.replace(' Airport','') }}
                </p>
              </div>
            </div>
            <div class="col-6">
              <p class="airport-title">{{ $t('airportArr') }}</p>
              <div class="airport-box">
                <p class="airport-iata">{{ selectedMarker.airportArrIata }} </p>
                <p class="airport-name">
                  {{ selectedMarker.airportArrName.replace(' Airport','') }}
                </p>
              </div>
            </div>
          </div>
          <div class="hours-box">
            <!-- <div class="row">
              <div class="col-6">
                <div class="row">
                  <div class="col-8">
                    <h3 class="flight-param without-top-margin">{{ $t('scheduledHour') }}</h3>
                  </div>
                  <div class="col-4">
                    <span>{{ selectedMarker.flightDepHour }}</span>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="row">
                  <div class="col-8">
                    <h3 class="flight-param without-top-margin">{{ $t('scheduledHour') }}</h3>
                  </div>
                  <div class="col-4">
                    <span>{{ selectedMarker.flightArrHour }}</span>
                  </div>
                </div>
              </div>
            </div> -->
            <div class="row">
              <div class="col-6">
                <div class="row">
                  <div class="col-8">
                    <h3 class="flight-param without-top-margin">{{ $t('estimatedHour') }}</h3>
                  </div>
                  <div class="col-4">
                    <span>{{ selectedMarker.flightDepTime }}</span>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="row">
                  <div class="col-8">
                    <h3 class="flight-param without-top-margin">{{ $t('estimatedHour') }}</h3>
                  </div>
                  <div class="col-4">
                    <span>{{ selectedMarker.flightArrTime }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row align-center">
            <h3 class="flight-state">{{ $t('flightStatus') }}</h3>
            <p>{{ $t(selectedMarker.flightStatus) }} </p>
          </div>
          <div class="row inline-param">
            <div class="col-4">
              <h3 class="flight-param without-top-margin">{{ $t('flightSpeed') }}</h3>
            </div>
            <div class="col-8">
              <span>{{ selectedMarker.flightSpeed }} Km/h</span>
            </div>
          </div>
          <div class="row center-content">
            <div class="col-4">
              <h3 class="flight-param">{{ $t('flightAltitude') }}</h3>
              <span>{{ selectedMarker.flightAltitude }} m</span>
            </div>
            <div class="col-4">
              <h3 class="flight-param">{{ $t('flightLatitude') }} </h3>
              <span>{{ selectedMarker.flightLatitude }}°</span>
            </div>
            <div class="col-4">
              <h3 class="flight-param">{{ $t('flightLongitude') }}</h3>
              <span>{{ selectedMarker.flightLongitude }}° </span>
            </div>
          </div>
        </div>
        <div class="sidenav-header-close">
          <button type="button" class="closebtn" @click="e => close(e)">
            &times;
          </button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'flight-map-sidebar',
  props: {
    selectedMarker: {
      type: Object,
      required: true,
    },
  },
  methods: {
    close(e) {
      document.getElementById('mySidenav').style.width = '0';
      this.$emit('closeSideBar', e);
    },
  },
};
</script>
<style scoped>

/** SIDENAV */
.sidenav {
  height: 530px;
  width: 350px;
  position: fixed;
  z-index: 1000;
  top: 15px;
  left: 20px;
  background-color: #fff;
  overflow-x: hidden;
  transition: 0.5s;
  border-radius: 15px;
}

.sidenav a {
  padding: 8px 8px 8px 32px;
  text-decoration: none;
  font-size: 25px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.sidenav a:hover {
  color: #f1f1f1;
}

.sidenav .closebtn {
  position: absolute;
  top: 5px;
  right: 25px;
  font-size: 36px;
  margin-left: 50px;
  background: none;
  border: none;
  color: #fff;
  cursor: pointer;
}

img.logo-datafuer {
  position: absolute;
  top: 25px;
  right: 5px;
  width: 50px;
}

@media screen and (max-height: 450px) {
  .sidenav {padding-top: 15px;}
  .sidenav a {font-size: 18px;}
}
.sidenav-header-title {
  color: white;
  background: #008996;
  padding: 5px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  position: relative;
}
.sidenav-content {
  color: #000;
}
.closebtn {
  font-size: 25px !important;
  right: 5px !important;
}

/** Header */
.sidenav-h3 {
  margin: 10px;
  margin-bottom: -5px;
}

.flight-iata{
  font-size: 2em;
}

.airline {
  margin: 0px;
  margin-left: 10px;
  color: bisque;
  font-size: 1.1em;
}

/** Content */
.sidenav-content {
  padding: 0px 10px;
}

/** Image */
img.airplane-img {
  width: 100%;
}

/** Airport section */

.airport-box {
  background: #efefef;
  border-radius: 10px;
  margin-left: 10px;
  margin-right: 10px;
  padding-bottom: 10px;
}
p.airport-title {
  font-size: 0.9em;
  margin-bottom: 0px;
  text-align: center;
}

p.airport-iata {
  font-size: 3.7em;
  margin: 0px;
  margin-bottom: -10px;
  text-align: center;
}

p.airport-name {
  text-align: center;
  margin: 0px;
}

/** Flight state */
.flight-state {
  margin-right: 1em;
}

.align-center {
  align-items: center;
}

/** Flight info */
.center-content > div {
  text-align: center;
}

h3.flight-param {
  margin-bottom: 0px;
  text-transform: uppercase;
  font-weight: 800;
  font-size: 11px;
}

.inline-param {
  margin-left: 22px;
  margin-top: 0px;
}

.without-top-margin {
  margin-top: 0px;
}

.hours-box {
  margin-top: 5px;
  margin-left: 15px;
}

/** grid */
.row {
  display: flex;
  justify-content: center;
}
.col-6 {
  width: 49.5%;
  margin: 0px 5px;
}
.col-4 {
  width: 33%;
  margin: 0px 5px;
}
.col-8 {
  width: 66%;
}
</style>
